/**
 * Created by jonas on 2021-02-19.
 */
    import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";


export interface SimplePresentationRunnerController {
    finish:() => void,
    setSkipCallback:(skipCallback?:Function) => void
}

export interface SimplePresentation {
    start(controller:SimplePresentationRunnerController):void;

    shouldRun():boolean;

    name?:string;
}

export class SimplePresentationRunner {

    private static log(prefix:string | undefined, message:string) {
        if(prefix == undefined) {
            return;
        }

        Logger.logDev(prefix + message);
    }

    public static run(presentations:SimplePresentation[], finishCallback:Function, setSkipCallback:(skipCallback?:Function) => void, logPrefix?:string) {
        const localPresentations = presentations.concat();
        const presentation:SimplePresentation | undefined = localPresentations.shift();
        if(presentation == undefined) {
            finishCallback();
        }
        else {
            const presentationName = presentation.name ? presentation.name : "unnamed presentation";

            if(presentation.shouldRun()) {
                SimplePresentationRunner.log(logPrefix, "starting: " + presentationName);
                presentation.start({
                    finish : () => {
                        SimplePresentationRunner.log(logPrefix, "finishing: " + presentationName);
                        SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback, logPrefix);
                    },
                    setSkipCallback : setSkipCallback
                });
            }
            else {
                SimplePresentationRunner.log(logPrefix, "skipping: " + presentationName);
                SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback, logPrefix)
            }
        }
    }
}